import { render, staticRenderFns } from "./FilesSharedWithUser.vue?vue&type=template&id=00fd873b&scoped=true&"
import script from "./FilesSharedWithUser.vue?vue&type=script&lang=js&"
export * from "./FilesSharedWithUser.vue?vue&type=script&lang=js&"
import style0 from "./FilesSharedWithUser.vue?vue&type=style&index=0&id=00fd873b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fd873b",
  null
  
)

export default component.exports